<h2 mat-dialog-title>

  <span *ngIf="selectedPartnerItem.name">{{'COMMON.EDIT' | translate}} - {{selectedPartnerItem.name}}</span>
  <span *ngIf="!selectedPartnerItem.name">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">


  <mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab class="modal-tab" label="{{'PARTNER.TAB.0' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'PARTNER.TAB.1' | translate}}"></mat-tab>
  </mat-tab-group>

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div [hidden]="activeTabIndex !== 1" class="uploader-container">
        <img *ngIf="selectedPartnerItem && selectedPartnerItem.imageUrl"
             [src]="selectedPartnerItem.imageUrl">
        <mat-icon class="dark" *ngIf="selectedPartnerItem && selectedPartnerItem.imageUrl"
                  (click)="deleteCoverImage()">delete
        </mat-icon>
        <app-custom-drop-zone
          *ngIf="!selectedPartnerItem || !selectedPartnerItem.imageUrl"
          (uploadFinished)="onUploadFinished($event)"
          [uploadPath]="'partner'"
          [height]="'250px'">
        </app-custom-drop-zone>
      </div>


      <div [hidden]="activeTabIndex !== 0">
        <div class="row">
          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'PARTNER.NAME' | translate}}"
                     formControlName="name">

            </mat-form-field>

          </div>

          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'PARTNER.DESCRIPTION' | translate}}"
                     formControlName="description">

            </mat-form-field>

          </div>

          <div class="col-12">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'PARTNER.LINK' | translate}}"
                     formControlName="link">

            </mat-form-field>

          </div>
          <div class="col-12">

            <mat-checkbox formControlName="isSupplier">{{'PARTNER.SUPPLIER' | translate}}</mat-checkbox>

          </div>

        </div>
      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
